<template>
  <div class="w-full overflow-y-scroll">
    <div class="mx-auto w-full md:max-w-md flex-none flex flex-row py-1 topnav w-full justify-start">
      <img class="w-10 h-10 ml-1 mr-0" src='/img/PBC_logo.svg' />
      <h3 class="ml-4 text-white font-bold text-2xl">playboxcade</h3>
    </div>

    <router-view />
    <user-posts class="mx-auto w-full md:max-w-md pt-8" :username='username'>
      <local-memes v-if='false && username === user.username' @claimed='onRefresh' />
    </user-posts>
  </div>
</template>
<script>
import LocalMemes from '@ui/organisms/LocalMemes.vue';
import { mapState } from 'vuex';
import UserPosts from '@ui/organisms/UserPosts.vue';
export default {
  components:{
    UserPosts,
    LocalMemes
  },
  methods:{
    onRefresh() {
      window.location.reload();
    },
  },
  computed: {
    username() {
      return this.$route.params.username;
    },
    ...mapState(['user'])
  },
}
</script>
